/**
 * Breadcrumbs Component
 * Auto-generated breadcrumbs from current route
 */

import React from 'react'
import { Link, useLocation } from 'react-router-dom'
import { Home } from 'lucide-react'
import {
  Breadcrumb,
  BreadcrumbList,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from '@/components/ui/breadcrumb'

interface BreadcrumbSegment {
  label: string
  path: string
}

const routeLabels: Record<string, string> = {
  '': 'Dashboard',
  'clients': 'Clients',
  'visits': 'Visits',
  'cases': 'Cases',
  'reports': 'Reports',
  'monthly': 'Monthly Reports',
  'annual': 'Annual Reports',
  'admin': 'Administration',
  'users': 'Users',
  'offices': 'Offices',
  'courts': 'Courts',
  'new': 'New',
  'edit': 'Edit',
}

function pathToSegments(pathname: string): BreadcrumbSegment[] {
  const parts = pathname.split('/').filter(Boolean)
  const segments: BreadcrumbSegment[] = []

  let currentPath = ''
  for (const part of parts) {
    currentPath += `/${part}`

    // Skip numeric IDs
    if (/^\d+$/.test(part)) {
      continue
    }

    segments.push({
      label: routeLabels[part] || part.charAt(0).toUpperCase() + part.slice(1),
      path: currentPath,
    })
  }

  return segments
}

export function Breadcrumbs() {
  const location = useLocation()
  const segments = pathToSegments(location.pathname)

  // Don't show breadcrumbs on home page
  if (segments.length === 0) {
    return null
  }

  return (
    <Breadcrumb className="mb-6">
      <BreadcrumbList>
        {/* Home link */}
        <BreadcrumbItem>
          <BreadcrumbLink asChild>
            <Link to="/" className="flex items-center gap-1">
              <Home className="h-4 w-4" />
              <span>Home</span>
            </Link>
          </BreadcrumbLink>
        </BreadcrumbItem>

        {/* Segments */}
        {segments.map((segment, index) => {
          const isLast = index === segments.length - 1

          return (
            <React.Fragment key={segment.path}>
              <BreadcrumbSeparator />
              <BreadcrumbItem>
                {isLast ? (
                  <BreadcrumbPage>{segment.label}</BreadcrumbPage>
                ) : (
                  <BreadcrumbLink asChild>
                    <Link to={segment.path}>{segment.label}</Link>
                  </BreadcrumbLink>
                )}
              </BreadcrumbItem>
            </React.Fragment>
          )
        })}
      </BreadcrumbList>
    </Breadcrumb>
  )
}

export default Breadcrumbs
